import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGameStore, PlayerInfo } from "@/stores/gameStore";
import { useUserInfoStore } from "@/stores/userInfoStore";
import PlayerInfoView from "@/views/game/PlayerInfoView.vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerInfoPresenter',
  setup(__props) {

const userInfoStore = useUserInfoStore();
const { displayName, profilePic, rating } = storeToRefs(userInfoStore);

const gameStore = useGameStore();
const { isAttacker } = gameStore;
const { opponentInfo } = storeToRefs(gameStore);

const myInfo = computed(() => {
  return {
    name: displayName.value,
    profilePic: profilePic.value,
    rating: rating.value,
  } as PlayerInfo;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PlayerInfoView, {
    "attacker-info": _unref(isAttacker) ? _unref(myInfo) : _unref(opponentInfo),
    "defender-info": _unref(isAttacker) ? _unref(opponentInfo) : _unref(myInfo)
  }, null, 8, ["attacker-info", "defender-info"]))
}
}

})